"use client";

import { Project, Service } from "@/types/home";
import { Page } from "@/types/navigation";
import { createContext, useContext, useDeferredValue } from "react";

const NavigationContext = createContext<{
  navigations: Page[];
  services: Service[];
  projects: Project[];
}>({
  navigations: [],
  services: [],
  projects: [],
});

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
};

export default function NavigationProvider({
  children,
  navigations,
  services,
  projects,
}: React.PropsWithChildren<{
  navigations: Page[];
  services: Service[];
  projects: Project[];
}>) {
  const navigationsValue = useDeferredValue(navigations);
  const servicesValue = useDeferredValue(services);
  const projectsValue = useDeferredValue(projects);

  return (
    <NavigationContext.Provider
      value={{
        navigations: navigationsValue,
        services: servicesValue,
        projects: projectsValue,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
}
